export default __webpack_public_path__ + "static/faherty_case_study_cover-3f7f6a6d07582e52c609d00b417a6453.png";